"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Dropdown/index.ts
var Dropdown_exports = {};
__export(Dropdown_exports, {
  Dropdown: () => Dropdown,
  DropdownAlignment: () => DropdownAlignment,
  DropdownContainer: () => DropdownContainer
});
module.exports = __toCommonJS(Dropdown_exports);

// src/components/Dropdown/Dropdown.tsx
var import_react3 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
function DropdownContainer({
  id,
  className,
  style,
  children
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "ul",
    {
      id,
      className: (0, import_classnames.default)(className, [
        "v2-flex v2-flex-col v2-h-auto v2-rounded-sm v2-shadow ",
        "v2-bg-white v2-absolute"
      ]),
      style
    },
    children
  );
}

// src/hook/use-detect-outside-click-hook.ts
var import_react2 = require("react");
function useDetectOutsideClick({
  container = document,
  containerRef,
  onDetect
}, deps) {
  (0, import_react2.useEffect)(() => {
    if (!(containerRef == null ? void 0 : containerRef.current))
      return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onDetect == null ? void 0 : onDetect();
      }
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleClickOutside);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, ...deps]);
}

// src/components/Dropdown/Dropdown.tsx
var DropdownAlignment = /* @__PURE__ */ ((DropdownAlignment2) => {
  DropdownAlignment2["Start"] = "flex-start";
  DropdownAlignment2["Center"] = "center";
  DropdownAlignment2["End"] = "flex-end";
  return DropdownAlignment2;
})(DropdownAlignment || {});
function Dropdown(_a) {
  var _b = _a, {
    id,
    className,
    active: defaultActive,
    body,
    children,
    closeOnOutsideClick = true,
    disabled = false,
    onClick,
    containerAlignment = "center" /* Center */,
    containerId,
    containerClassName,
    containerRef,
    width = 210
  } = _b, otherProps = __objRest(_b, [
    "id",
    "className",
    "active",
    "body",
    "children",
    "closeOnOutsideClick",
    "disabled",
    "onClick",
    "containerAlignment",
    "containerId",
    "containerClassName",
    "containerRef",
    "width"
  ]);
  const ref = containerRef != null ? containerRef : (0, import_react3.useRef)(null);
  const bodyRef = (0, import_react3.useRef)(null);
  const [active, setActive] = (0, import_react3.useState)(defaultActive);
  (0, import_react3.useEffect)(() => {
    setActive(defaultActive);
  }, [defaultActive]);
  const toggleDropdown = () => {
    if (!disabled) {
      setActive(!active);
      onClick == null ? void 0 : onClick(!active);
    }
  };
  useDetectOutsideClick(
    {
      containerRef: ref,
      onDetect: () => {
        if (closeOnOutsideClick && active) {
          toggleDropdown();
        }
      }
    },
    [active]
  );
  const defaultStyle = { width };
  const containerStyle = (0, import_react3.useMemo)(() => {
    var _a2;
    if (bodyRef.current) {
      const buttonRect = (_a2 = bodyRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      return __spreadValues({
        marginTop: buttonRect.height
      }, defaultStyle);
    }
    return __spreadValues({}, defaultStyle);
  }, [bodyRef.current]);
  return /* @__PURE__ */ import_react3.default.createElement(
    "div",
    __spreadValues({
      id,
      className: (0, import_classnames2.default)(className, ["v2-flex v2-flex-col"]),
      style: {
        alignItems: containerAlignment
      },
      ref
    }, otherProps),
    /* @__PURE__ */ import_react3.default.createElement(
      "div",
      {
        onClick: toggleDropdown,
        ref: bodyRef,
        className: "v2-h-full v2-w-full"
      },
      body
    ),
    (bodyRef == null ? void 0 : bodyRef.current) && /* @__PURE__ */ import_react3.default.createElement(
      DropdownContainer,
      {
        id: containerId,
        className: (0, import_classnames2.default)(containerClassName, ["v2-transition"], {
          "v2-animate-fade-in": active,
          "v2-hidden": !active
        }),
        style: containerStyle
      },
      children
    )
  );
}
